import React from 'react';
import { statusLabel, statusPillClass } from '../utils/lists-utils';

/** Active / Inactive pill shared by all three Lists pages. */
export const StatusPill: React.FC<{ isActive: boolean }> = ({ isActive }) => (
    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${statusPillClass(isActive)}`}>
        {statusLabel(isActive)}
    </span>
);

export default StatusPill;
